module.exports = __webpack_public_path__ + "img/roodie.2a6242c3.svg";